import Pusher from "pusher-js";
import Echo from "laravel-echo";
import PropTypes from "prop-types";
import React, { createContext, useCallback, useContext, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authSelectors } from "../../redux/auth";
import { configSelectors } from "../../redux/config";
var LaravelEchoContext = /*#__PURE__*/ createContext(null);
export function useLaravelEchoContext() {
    return useContext(LaravelEchoContext);
}
LaravelEchoContextProvider.propTypes = {
    children: PropTypes.node.isRequired
};
export default function LaravelEchoContextProvider(param) {
    var children = param.children;
    var dispatch = useDispatch();
    var pusherAppKey = useSelector(configSelectors.pusherAppKey);
    var apiHost = useSelector(configSelectors.apiHost);
    var userId = useSelector(authSelectors.userId);
    var tenantId = useSelector(authSelectors.tenantId);
    var echo = useRef();
    var listen = useCallback(function(channelName, eventName, callback) {
        var finalChannelName = channelName;
        try {
            if (channelName === "tenants") {
                finalChannelName = "".concat(channelName, ".").concat(tenantId);
            }
            if (channelName === "users") {
                finalChannelName = "".concat(channelName, ".").concat(userId);
            }
            // Set up the listener on the private channel
            echo.current.private(finalChannelName).listen(".".concat(eventName), callback);
            // Return a cleanup function
            return function() {
                echo.current.leave(finalChannelName);
            };
        } catch (err) {
            return false;
        }
    }, [
        tenantId,
        userId
    ]);
    useEffect(function() {
        echo.current = new Echo({
            Pusher: Pusher,
            broadcaster: "pusher",
            key: pusherAppKey,
            cluster: "eu",
            forceTLS: true,
            authorizer: function(channel) {
                return {
                    authorize: function(socketId, callback) {
                        return dispatch(function(dispatch, getState, param) {
                            var httpClient = param.httpClient;
                            return httpClient.post("".concat(apiHost, "/broadcasting/auth"), {
                                socket_id: socketId,
                                channel_name: channel.name
                            }).then(function(response) {
                                return callback(null, response.data);
                            }).catch(function(error) {
                                return callback(error);
                            });
                        });
                    }
                };
            }
        });
        return function() {
            echo.current.disconnect();
            echo.current = null;
        };
    }, []);
    return /*#__PURE__*/ React.createElement(LaravelEchoContext.Provider, {
        value: {
            listen: listen
        }
    }, children);
}
